module.exports = __webpack_public_path__ + "/build/web/images/hero@3x.271369230f4fcaa20f8ffa1ea51d280c.jpg";


//////////////////
// WEBPACK FOOTER
// ./images/hero@3x.jpg
// module id = 159
// module chunks = 13